import getPersonalSchedulingPageOperation from 'owa-service/lib/operation/getPersonalSchedulingPageOperation';
import GetPersonalSchedulingPageJsonResponse from 'owa-service/lib/contract/GetPersonalSchedulingPageJsonResponse';
import GetPersonalSchedulingPageResponseMessage from 'owa-service/lib/contract/GetPersonalSchedulingPageResponseMessage';
import GetPersonalSchedulingPageJsonRequest from 'owa-service/lib/contract/GetPersonalSchedulingPageJsonRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Service call to get personal booking page settings.
 */
export default async function getPersonalBookingPageSettings(): Promise<
    GetPersonalSchedulingPageResponseMessage
> {
    let request: GetPersonalSchedulingPageJsonRequest = {
        Header: getJsonRequestHeader(),
        Body: {},
    };

    let response: GetPersonalSchedulingPageJsonResponse = await getPersonalSchedulingPageOperation(
        request
    );

    let result: GetPersonalSchedulingPageResponseMessage = null;
    if (response && response.Body && response.Body.ResponseClass === 'Success') {
        result = response.Body;
    }

    return result;
}
